<script>
import MainLayout from '@/router/layouts/mainLayout'
import VehicleListComponent from '@/components/VehicleListComponent'

import {DateUtil} from '@/utils/date.js'
export default {
  components: {
    MainLayout, VehicleListComponent
  },
  created () {
    // var self = this
    let dateStr = this.$route.query.currentDate
    if (dateStr) {
      this.currentDate = DateUtil.str2DateyMd(dateStr)
      dateStr = dateStr.substr(0, 6)
    } else if (sessionStorage.getItem('vehicleCurrentDate')) {
      this.currentDate = DateUtil.str2DateyMd(sessionStorage.getItem('vehicleCurrentDate'))
      dateStr = sessionStorage.getItem('vehicleCurrentDate').substr(0, 6)
    } else {
      this.currentDate = new Date()
      let month = this.currentDate.getMonth() + 1
      dateStr = this.currentDate.getFullYear() + '' + (month < 10 ? '0' + month : month)
    }
    this.loading = true
    this.$axios.get('vehicle/queryAllVehicleInfos', {params: {date: dateStr}})
      .then(response => {
        this.vehicleList = response.data.vehicleInfos
        this.loading = false
      })
      .catch(error => {
        console.log(error)
      })
  },
  data () {
    return {
      title: '車両リスト',
      vehicleList: [],
      currentDate: null,
      isPrint: false,
      loading: false
    }
  },
  methods: {
    vehicleLogin () {
      this.$router.push({name: 'VehicleLogin'})
    },
    changePrint () {
      this.title = '[出力]車両リスト'
      this.isPrint = true
    },
    cancelPrint () {
      this.title = '車両リスト'
      this.isPrint = false
    }
  }
}
</script>

<template>
<main-layout>
  <div class="col-md-12 column" style="height:calc(100% - 120px);">
    <div class="row clearfix">
        <div class="col-md-12 column header">
          <div class="row clearfix">
            <div class="col-md-4 column">
            </div>
            <div class="col-md-4 column F3-M-27">{{title}}</div>
            <div class="col-md-4 column headerbtndiv">
              <div class="user-btn"></div>
              <div class="common-btn user-btn F2-M-19" @click="changePrint">一覧出力</div>
              <div class="common-btn user-btn F2-M-19" @click="vehicleLogin">+ 新規登録</div>
            </div>
          </div>
        </div>
    </div>
    <vehicle-list-component
      :vehicleList="vehicleList"
      :currentDate="currentDate"
      :is-print="isPrint"
      @cancelPrint="cancelPrint">
    </vehicle-list-component>
  </div>
</main-layout>
</template>

<style lang="scss" scoped>
@import "../../assets/css/C00.css";
.buttonSty {
  & > button {
    position: relative;
    left: 70px;
  }
}
  .header{
    padding-top: 18px;
    padding-bottom: 18px;
  }
  .name-strong{
    font-size: 30px;
  }
  .right-part{
    display: flex;
    justify-content: flex-end;
  }
  .common-btn{
    width: 45%;
    height: 38px;
    border-radius: 25px;
    font-size: 18px;
    background: linear-gradient(rgb(167, 167, 165) 50%, rgb(145,146,141) 50%);
    border: 0px;
    margin:0 5px;
  }
  .vehicle-list-items{
    padding: 10px;
  }
  .vehicle-list-item{
    height: 140px;
    background: rgb(219, 219, 219);
    padding: 5px;
    margin-top: 20px;
  }
  .left-item{
    padding-left: 5px;
    padding-right:5px;
  }
  .item-icon{
    height: 130px;
    background: rgb(120, 120, 120);
  }
  .top-item{
    background: #fff;
    height: 80px;
    padding: 10px;
  }
  .item-title{
    line-height: 60px;
    text-align: left;
    border-right: rgb(219, 219, 219) solid 2px;
    font-size: 30px;
  }
  .item-id{
    line-height: 60px;
    border-right: rgb(219, 219, 219) solid 2px;
    font-size: 20px;
  }
  .item-number{
    line-height: 60px;
    font-size: 20px;
  }
  .bottom-item{
    font-size: 20px;
    text-align: left;
    height: 50px;
    padding: 10px;
  }
  .item-vehicle{
    line-height: 30px;
    border-right: rgb(120, 120, 120) solid 2px;
  }
  .item-distance{
    line-height: 30px;
  }
  .headerbtndiv {
    display: flex;
    // float: right; // width: 420px;想要按钮固定式可以设置该div的宽度
    .user-btn {
      margin-right: 5px;
      flex: 1;
      // width: auto
    }
  }
</style>



// WEBPACK FOOTER //
// src/router/views/VehicleList.vue